import React, { useEffect, useState } from "react"
import "./ViewCategory.scss"
import { useNavigate, useParams } from "react-router-dom"
import CategoryApi from "Api/CategoryApi"
import { InputText } from "primereact/inputtext"
import { Card, CardBody, Col, Row,Button } from "reactstrap"
import CustomBreadCrumb from "utils/CustomBreadCrumb/CustomBreadCrumb"

const ViewCategory = () => {
  document.title = "View Category"

  const navigate = useNavigate("")
  const accessToken = localStorage.getItem("accessToken")
  const { categoryCode } = useParams()

  const [catgeoryData, setCategoryData] = useState([])
  const breadcrumbItems = [
    { label: "Pixwik", link: "#" },
    { label: "Category", link: "#" },
    { label: "View Category", link: "#" },
  ]

  const getCategoryDetails = categoryCode => {
    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
    CategoryApi.getCategoryById(categoryCode, config)
      .then(res => {
        if (res.data.status) {
          setCategoryData(res.data.data)
        }
      })
      .catch(error => {
        console.log(error)
      })
  }

  useEffect(() => {
    if (categoryCode) {
      getCategoryDetails(categoryCode)
    }
  }, [categoryCode])

  return (
    <div className="view-category">
      <Row>
        <Col xs="12">
          <div className="category-list-header d-flex  align-items-center justify-content-between">
            <CustomBreadCrumb
              data={breadcrumbItems}
              pageTitle="View Category"
            />
          </div>

          <Card className="mt-4 ">
            <CardBody>
              <div className="category-view-form ">
                <div className="category-view-inp">
                  <label htmlFor="categoryName" className="label">
                    Category Name
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="categoryName"
                      value={catgeoryData.categoryName}
                      className="inp-field-box"
                      disabled
                    />
                  </div>
                </div>
                <div className="category-view-inp">
                  <label htmlFor="description" className="label">
                    Description
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="description"
                      value={catgeoryData.description}
                      className="inp-field-box"
                      disabled
                    />
                  </div>
                </div>
                <div className="category-view-inp">
                  <label htmlFor="verifiedStatus" className="label">
                    Verified Status
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="verifiedStatus"
                      value={
                        catgeoryData.verifiedStatus === "approve"
                          ? "Yes"
                          : "No"
                            ? "Yes"
                            : "No"
                      }
                      className="inp-field-box"
                      disabled
                    />
                  </div>
                </div>
                <div className="category-view-inp">
                  <label htmlFor="verifiedReason" className="label">
                    Verified Reason
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="verifiedReason"
                      value={
                        catgeoryData.verifiedReason
                          ? catgeoryData.verifiedReason
                          : "-"
                      }
                      className="inp-field-box"
                      disabled
                    />
                  </div>
                </div>
                <div className="save-cancel-btn mt-4 d-flex align-items-center justify-content-start gap-3">
                <Button
                  type="button"
                  outline
                  color="danger"
                  className="waves-effect waves-light"
                  onClick={() => {
                    navigate(-1)
                  }}
                >
                  Back
                </Button>
              </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  )
}

export default ViewCategory
